// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c4513a4","239":"bb9be1d9","455":"9de7e650"}[chunkId] + ".chunk.js";
};